import { render } from "./InfoBox.vue?vue&type=template&id=6b9d28a3&ts=true"
import script from "./InfoBox.vue?vue&type=script&lang=ts"
export * from "./InfoBox.vue?vue&type=script&lang=ts"

import "./InfoBox.vue?vue&type=style&index=0&id=6b9d28a3&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__